import React, { useId, useState } from 'react';
import Icon from './Icon';

export function PipelineMap({ nodes, active = 1 }) {
  return (
    <ol className="pipeline-map" aria-label="Conceptual system sequence">
      {nodes.map((node, index) => (
        <li key={`${index}-${node}`} className={index === active % nodes.length ? 'node-active' : ''}>
          <span className="node-index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
          <span>{node}</span>
          {index < nodes.length - 1 && <Icon kind="down" />}
        </li>
      ))}
    </ol>
  );
}

export default function SystemStudy({ project, compact = false }) {
  const [stageIndex, setStageIndex] = useState(0);
  const regionId = useId();
  const stage = project.stages[stageIndex];
  return (
    <div className={`system-study ${compact ? 'system-study-compact' : ''}`}>
      <div className="system-study-header">
        <span className="eyebrow">Follow the system</span>
        <span className="system-reference">{project.collaboration ? 'Collaboration' : 'Owned study'} {project.number} / {project.category}</span>
      </div>
      <div className="stage-controls" role="group" aria-label="Explore the engineering decisions">
        {project.stages.map((item, index) => (
          <button key={item.id} type="button" aria-pressed={index === stageIndex} aria-controls={regionId} onClick={() => setStageIndex(index)}>
            <span aria-hidden="true">0{index + 1}</span>{item.label}
          </button>
        ))}
      </div>
      <div className="system-study-body" id={regionId}>
        <div className="stage-story" aria-live="polite" aria-atomic="true">
          <span className="stage-label">{stage.label} / 0{stageIndex + 1}</span>
          <h3>{stage.title}</h3>
          <p>{stage.body}</p>
          <ul className="stage-notes">{stage.notes.map(note => <li key={note}>{note}</li>)}</ul>
        </div>
        <figure className="stage-diagram">
          <PipelineMap nodes={stage.nodes} active={stageIndex} />
          <figcaption>Conceptual sequence · based on the project narrative</figcaption>
        </figure>
      </div>
      <div className="constraint-ledger">
        <span className="eyebrow">The constraint ledger</span>
        <span>{project.headlineMetric.value} <span className="ledger-caption">{project.headlineMetric.label}</span></span>
      </div>
    </div>
  );
}
